export const COLLAPSED_WIDTH = 525;
export const RIGHT_DETAILS_PANEL_WIDTH = 400;
